"use strict";
var _a;
exports.__esModule = true;
exports.actionLogToSelectedEvent = void 0;
var types_1 = require("./types");
var analytics_1 = require("@genoa/analytics");
/**
 * map of `ActionLogType`s used as options in the `how-you-use-flex` and `autopay-setup` screens
 * to the corresponding analytic event to fire when one is selected
 */
exports.actionLogToSelectedEvent = (_a = {},
    _a[types_1.ActionLogType.SELECT_PRODUCT_CREDIT_BUILDER] = analytics_1.Analytics.Events.SELECT_CREDIT_BUILDER_PRESSED,
    _a[types_1.ActionLogType.SELECT_PRODUCT_SPLIT_RENT] = analytics_1.Analytics.Events.SELECT_SPLIT_RENT_PRESSED,
    // Actions
    _a[types_1.SetupAutopilotAction.AUTOPAY_ON] = analytics_1.Analytics.Events.AUTOPILOT_SET_UP_AUTOPAY_PRESSED,
    _a[types_1.SetupAutopilotAction.EPISODIC_ON] = analytics_1.Analytics.Events.AUTOPILOT_SKIP_AUTOPAY_PRESSED,
    _a);
